// A timestamp somebody reads, from one the database wrote.
//
// Postgres hands back microseconds -- "2026-09-04 16:24:58.429996" -- and the API passes them
// through as-is, which is right: the stored value is evidence and should not be rounded on its way
// out. But nobody reads microseconds, and in an approval history the six digits are longer than the
// thing they qualify.
//
// TRIMMED FOR DISPLAY ONLY. Nothing here changes what was stored or what is returned; a dossier
// that needs the full precision reads the row.

/** "2026-09-04 16:24:58.429996" or an ISO string -> "2026-09-04 16:24:58". */
export function formatMoment(value: any) {
    if (!value) return "";
    const text = String(value).replace("T", " ").replace("Z", "");
    // Second precision: the fraction is never what somebody is reading for, and its absence is not
    // a loss of information anybody looking at a list can act on.
    const match = text.match(/^(\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})/);
    return match ? match[1] : text;
}
